<template>
	<div class="recuperar-pw">
		<div class="recuperar-pw-container">
			<div class="recuperar-pw-left">
				<div class="tiras-top">
					<div class="tira-azul"></div>
					<div class="tira-roja"></div>
				</div>
				<div class="recuperar-pw-form">
					<router-link :to="{ name: 'home' }" class="logo">
						<img src="../../assets/LogoNacionalTickets.svg" alt="Nacional Tickets">
						<span>Nacional<br>Tickets</span>
					</router-link>
					<h1>Olvidé mi contraseña</h1>
					<p>Indica tu correo electrónico para recuperar tu contraseña. Te enviaremos un mail con los pasos detallados.</p>
					<div class="recuperar-pw-errors" v-if="$store.state.erroresRecuperarPw.length">
						<ul>
							<li>{{ this.$store.state.erroresRecuperarPw[0].msg }}</li>
						</ul>
					</div>
					<form action="" @submit.prevent="olvidePassword" novalidate="true">
						<div class="input-group">
							<label for="email">Correo electrónico</label>
							<input tabindex="1" type="email" name="email" id="email" placeholder="prudencio@reyes.com" v-model="email">
							<!-- <at-sign-icon></at-sign-icon> -->
						</div>
						<div class="input-row">
							<VueLoadingButton type="submit" aria-label="" :loading="isLoadingBoton" tabindex="2">Recuperar contraseña</VueLoadingButton>
						</div>
						<div class="iniciar-sesion">
							<span>¿Recordaste tu contraseña?</span>
							<router-link :to="{name: 'login' }" tabindex="3">Iniciar sesión</router-link>
						</div>
					</form>
				</div>
				<div class="footer">
					<span>Club Nacional de Football © {{ new Date().getFullYear() }}</span>
				</div>
			</div>
			<auth-right></auth-right>
		</div>
	</div>
</template>

<script>
	import VueLoadingButton from 'vue-loading-button'
	import AuthRight from '../../components/Shared/AuthRight.vue'

	export default {
		name: 'olvide-password',
		data() {
			return {
				email: '',
				isLoadingBoton: false
			}
		},
		components: {
			'auth-right': AuthRight,
			VueLoadingButton
		},
		beforeCreate(){
			// Redirijo a Nacional.uy
			window.location.href = process.env.VUE_APP_URL_NACIONALUY;
			
			// if(this.$store.getters.loggedIn === true){
			// 	this.$router.push({ name: 'home' })
			// }
		},
		methods: {
			olvidePassword() {
				this.isLoadingBoton = true;
				this.$store.commit('limpiarErroresRecuperarPw');

				if(!this.email){
					this.$store.commit('insertarErrorRecuperarPw', 'Debes ingresar un correo electrónico');
					this.isLoadingBoton = false;
				} else {
					if(!this.validarEmail(this.email)){
						this.$store.commit('insertarErrorRecuperarPw', 'Correo electrónico no válido');
						this.isLoadingBoton = false;
					} else {
						this.$store.dispatch('recuperarPassword', {
							email: this.email,
						})
						.then(response => {
							this.isLoadingBoton = false;

							// Mostrar notificación de que se le envió el mail
							this.$toast.success('Te enviamos un mail con los pasos a realizar para recuperar tu contraseña', {
								position: "bottom-left",
								timeout: 7000,
								closeOnClick: true,
								pauseOnFocusLoss: false,
								pauseOnHover: true,
								draggable: false,
								draggablePercent: 0.6,
								showCloseButtonOnHover: true,
								hideProgressBar: true,
								closeButton: "button",
								icon: true,
								rtl: false
							});
						})
						.catch(error => {
							this.isLoadingBoton = false;
						})
					}
				}
			},
			validarEmail(email) {
				var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				return re.test(email);
			}
		}
	}
</script>

<style lang="scss">
	.spinner{
		top: calc(50% - 3px) !important;
	}

	.spinner span{
		border-width: 2px !important;
		border-color: #fff transparent transparent transparent !important;
	}
</style>

<style scoped lang="scss">
	@import '../../styles/typography.scss';
	@import '../../styles/mixins.scss';

	.recuperar-pw{
		height: 100%;
		width: 100%;
		margin: 0;
		padding: 0;
		position: relative;

		.recuperar-pw-container{
			width: 100%;
			height: 100vh;
			@include flex(row, space-betweeen, center);
			position: relative;
			padding: 0;

			.recuperar-pw-left{
				position: relative;
				width: 800px;
				height: 100vh;
				padding: 0px 24px;
				margin: 0;
				@include flex(column, space-between, center);

				.recuperar-pw-form{
					margin: 0;
					padding: 0;
					width: 100%;
					max-width: 450px;

					.logo{
						@include flex(row, flex-start, center);
						margin: 0;
						margin-bottom: 15px;
						text-decoration: none;
						color: #c61431;
						max-width: 150px;

						img{
							height: 36px;
							width: auto;
							margin-right: 15px;
						}

						span{
							// font-family: 'Bungee', sans-serif;
							font-size: 17px;
							color: #c61431;
							line-height: 1.2em;
						}

						&:hover{
							text-decoration: none;
						}
					}

					h1{
						font-size: 28px;
						margin: 0;
						margin-top: 15px;
						font-weight: 300;
						color: #29355c;
						display: inline-block;
					}

					p{
						margin: 10px 0;
						margin-top: 0;
						color: #29355c;
						font-size: 14px;
					}

					.recuperar-pw-errors{
						@include flex(row, flex-start, center);
						width: 100%;
						padding: 0;
						margin: 10px 0;

						ul{
							list-style: none;
							margin: 0;
							padding: 0;

							li{
								width: 100%;
								font-size: 13px;
								font-weight: 700;
								color: #c61431;
								line-height: 1.5em;
							}
						}
					}

					form{
						width: 100%;
						@include flex(column, flex-start, flex-start);

						.input-group{
							width: 100%;
							margin: 8px 0;
							position: relative;
							@include flex(column, flex-start, flex-start);

							svg{
								color: rgba(48, 62, 103, 0.5);
								width: 18px;
								height: 18px;
								position: absolute;
								top: 33px;
								left: 15px;
							}

							label{
								margin-bottom: 4px;
								font-weight: 600;
								// color: rgba(23, 46, 132, 1);
								color: #29355c;
								font-size: 13px;
							}

							input{
								width: 100%;
								outline: none;
								border: 1px solid #e6e6e6;
								border-radius: 4px;
								padding: 12px 14px;
								font-size: 13px;
								background-color: #fff;
								box-shadow: none;
								transition: all .2s;
								color: #29355c;
								@include sinApariencia();

								&:focus{
									background-color: #fff;
									border: 1px solid #007bff;
								}
							}
						}

						.input-row{
							margin: 15px 0;
							width: 100%;
							padding: 0;
							@include flex(row, space-between, center);
						}

						button{
							width: 100%;
							margin: 0;
							padding: 13px;
							background-color: #11244d;
							color: #fff;
							font-weight: 400;
							font-size: 12px;
							text-transform: uppercase;
							letter-spacing: 2px;
							outline: none;
							border: none;
							border-radius: 5px;
							cursor: pointer;
							transition: all .2s;

							&:hover{
								background-color: #c61431;
							}

							&:disabled{
								color: rgba(27, 46, 75, 0.9);
								background-color: #ddd;
								cursor: not-allowed;
							}
						}

						.login-link{
							@include flex(row, flex-start, center);

							a{
								color: #007bff;
								transition: all .2s;
								font-size: 14px;
								line-height: 1em;
								@include flex(row, center, center);

								&:focus{
									outline: none;
									opacity: 0.9;
								}
							}

							svg{
								width: 14px;
								height: 14px;
								margin-right: 5px;
								margin-bottom: 1px;
							}
						}

						.iniciar-sesion{
							width: 100%;
							@include flex(row, center, center);
							padding: 10px 0;

							span{
								font-weight: 300;
								font-size: 14px;
								margin-right: 3px;
							}

							a{
								font-weight: 500;
								font-size: 14px;
								margin-left: 3px;
							}
						}
					}
				}

				.tiras-top{
					height: 50px;
					width: 30px;
					background-color: #fff;
					margin-bottom: 40px;
					@include flex(row, space-between, center);

					.tira-azul{
						background-color: #172e84;
						margin: 0;
						padding: 0;
						width: 10px;
						height: 100%;
					}

					.tira-roja{
						background-color: #c61431;
						margin: 0;
						padding: 0;
						width: 10px;
						height: 100%;
					}
				}

				.footer{
					width: 100%;
					padding: 20px 0;
					@include flex(column, center, center);

					span{
						font-weight: 400;
						font-size: 12px;
						line-height: 1em;
					}
				}
			}
		}
	}

	/* Responsive */
	@media screen and (max-width: 1360px){
		.recuperar-pw{
			.recuperar-pw-container{
				.recuperar-pw-left{
					width: 700px;
				}

				.auth-right{
					width: calc(100% - 700px);
				}
			}
		}
	}

	@media screen and (max-width: 1260px){
		.recuperar-pw{
			.recuperar-pw-container{
				.recuperar-pw-left{
					width: 600px;
					
					.recuperar-pw-form{
						max-width: 380px;
					}
				}

				.auth-right{
					width: calc(100% - 600px);
					background-size: auto;
				}
			}
		}
	}

	@media screen and (max-width: 960px){
		.recuperar-pw{
			.recuperar-pw-container{
				.recuperar-pw-left{
					width: 100%;
					
					.recuperar-pw-form{
						max-width: 450px;
					}
				}

				.auth-right{
					display: none;
				}
			}
		}
	}
</style>